<template lang="pug">
basic-panel
  template(v-slot:header)
    .text-lg.capitalize.font-medium {{acc.account_name}}

  .container.flex(class="flex-col lg:flex-row")
    .flex-1.p-4
      .m-b-2.font-semibold.text-gray-600 {{ $t('payout.net_sales') }}
      .font-semibold.text-2xl.text-green-400 {{ acc.net | amount(payout.currency) }}
      .flex.flex-row.m-t-2.text-gray-600.font-medium
          .flex-1 {{ $t('payout.donations') }} {{ acc.net_breakdown.donations | amount(payout.currency) }}
          .flex-1.text-right {{ $t('payout.sales') }} {{ acc.net_breakdown.sales | amount(payout.currency) }}
    .flex-1.p-4.border-l.border-gray-200
      .m-b-2.font-semibold.text-gray-600 {{ $t('payout.deducted_fees') }}
      .font-semibold.text-2xl.text-gray-800 {{ acc.fee | amount(payout.currency) }}
      .flex.flex-row.m-t-2
          .flex-1.text-gray-500 {{ $t('payout.transaction_costs') }}
    .flex-1.p-4.border-l.border-gray-200
      .m-b-2.font-semibold.text-gray-600 {{ $t('payout.gross_sales') }}
      .font-semibold.text-2xl {{ acc.amount | amount(payout.currency) }}
      .flex.flex-row.m-t-2.font-medium.text-gray-600
        .flex-1
          a.text-blue-500(@click.prevent="showTransactions = !showTransactions", href="") {{ acc.transactions.length }} {{ $t('payout.transactions') }}
        .flex-1.text-right.capitalize {{firstTransactionDate(acc.transactions) | friendly_short_date }} - {{lastTransactionDate(acc.transactions) | friendly_short_date }}
  .py-2.border-t.border-gray-200(v-show="showTransactions")
    table
      tr
        th.amount-col-header.py-3.px-4 {{ $t('payout.net') }}
        th.amount-col-header.py-3.px-4 {{ $t('payout.fee') }}
        th.amount-col-header.py-3.px-4 {{ $t('payout.amount') }}
        th.product-col-header.py-3.px-4 {{ $t('payout.description') }}
        th.py-3.px-4 {{ $t('payout.date') }}
      template(v-for="transaction in acc.transactions")
        tr(:key="transaction.id")
          td.amount.py-3.px-4 {{ transaction.net | amount(transaction.currency) }}&nbsp;
            span.uppercase {{ transaction.currency }}
          td.amount.text-gray-600.py-3.px-4 {{ transaction.fee | amount(transaction.currency) }}&nbsp;
            span.uppercase {{ transaction.currency }}
          td.amount.text-gray-600.py-3.px-4 {{ transaction.amount | amount(transaction.currency) }}&nbsp;
            span.uppercase {{ transaction.currency }}
          td.text-gray-600.py-3.px-4 {{ transaction.description }}
          td.date.py-3.px-4 {{ transaction.created_at | friendly_date_time }}
</template>

<script>
export default {
  data() {
    return {
      showTransactions: false,
    };
  },
  props: ['acc', 'payout'],
  methods: {
    firstTransactionDate(transactions) {
      if (transactions.length === 0) {
        return '';
      }

      return transactions[transactions.length - 1].created_at;
    },
    lastTransactionDate(transactions) {
      if (transactions.length === 0) {
        return '';
      }

      return transactions[0].created_at;
    },
  },
};
</script>

<style lang="sass" scoped>

@import '../variables.sass'

table
  border-spacing: 0
  overflow-x: auto
  position: relative
  white-space: nowrap
  width: 100%
  -webkit-overflow-scrolling: touch
  & > *
    transform: translate3d(0, 0, 0)
  th
    color: $mutedColor
    font-size: 12px
    text-align: left
    &.amount-col-header
      text-align: right
    &.date-col-header
      text-align: right
    &.product-col-header
      width: 100%
  tr
    td
      border-top: 1px solid #eee
      &.status-col
        text-transform: uppercase
        text-align: center
      &.amount
        font-weight: 500
        text-align: right
      &.date
        text-transform: capitalize
        text-align: right
      span.last4
        padding-left: 10px
    &:hover, &.open
      td:not(.transactionInfo)
        cursor: pointer
        background-color: rgba($mutedColor, .05)
</style>
